import React from 'react';
import Icon from '../../../components/AppIcon';

const SupplierStats = ({ suppliers, language }) => {
  const stats = [
    {
      icon: 'Building2',
      label: language === 'en' ? 'Total Suppliers' : '总供应商',
      value: suppliers?.length,
      color: 'text-primary'
    },
    {
      icon: 'BadgeCheck',
      label: language === 'en' ? 'Verified' : '已验证',
      value: suppliers?.filter(s => s?.verified)?.length,
      color: 'text-success'
    },
    {
      icon: 'Coffee',
      label: language === 'en' ? 'Total Varieties' : '总品种',
      value: suppliers?.reduce((sum, s) => sum + s?.varietiesOffered, 0),
      color: 'text-secondary'
    },
    {
      icon: 'Globe',
      label: language === 'en' ? 'Countries' : '国家',
      value: new Set(suppliers.map(s => s.country_en))?.size,
      color: 'text-accent'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-5 hover:shadow-md transition-smooth"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center ${stat?.color}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className={`text-3xl font-heading font-bold ${stat?.color}`}>
              {stat?.value}
            </div>
          </div>
          <div className="text-sm text-muted-foreground font-medium">
            {stat?.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SupplierStats;